import React from 'react';
import { Svg } from 'src/components/Svg/Svg';
import { socialLinks } from 'src/config';
import { FooterAction } from 'src/components/Footer/FooterAction';
import { WhatsAppChat } from 'src/components/WhatsAppChat/WhatsAppChat';
import classnames from 'classnames';

import classes from './FooterContact.scss';

export const FooterContact = ({ theme }: { theme: 'white' | 'black' }) => (
    <div
        className={classnames(classes.container, {
            [classes.black]: theme === 'black',
            [classes.white]: theme === 'white',
        })}
    >
        <ul className={classes.footerSocial}>
            <li>
                <WhatsAppChat isFooterElement theme={theme} />
            </li>
            <li>
                <a
                    className={classes.footerSocialLink}
                    href={socialLinks.facebook}
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label="Facebook"
                >
                    <Svg name="facebook" />
                </a>
            </li>
            <li className={classes.footerSocialItem}>
                <a
                    className={classes.footerSocialLink}
                    href={socialLinks.instagram}
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label="Instagram"
                >
                    <Svg name="instagram" />
                </a>
            </li>
            <li className={classes.footerSocialItem}>
                <a
                    className={classes.footerSocialLink}
                    href={socialLinks.linkedin}
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label="LinkedIn"
                >
                    <Svg name="linkedin" />
                </a>
            </li>
            <li className={classes.footerSocialItem}>
                <a
                    className={classes.footerSocialLink}
                    href={socialLinks.twitter}
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label="Twitter"
                >
                    <Svg name="twitter" />
                </a>
            </li>
            <li className={classes.footerSocialItem}>
                <a
                    className={classes.footerSocialLink}
                    href={socialLinks.youtube}
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label="YouTube"
                >
                    <Svg name="youtube" />
                </a>
            </li>
        </ul>

        {theme === 'white' && <FooterAction className={classes.footerContactAction} />}

        <p
            className={classnames(classes.footerCopyright, {
                [classes.black]: theme === 'black',
                [classes.white]: theme === 'white',
            })}
        >
            © Workwear Express Ltd Company No. 3743499
        </p>

        {theme === 'white' && (
            <>
                <p className={classes.footerTerms}>
                    <a className={classes.footerTerms} href="/terms-conditions">
                        Terms & Conditions
                    </a>
                </p>

                <div className={classes.footerPoliciesContainer}>
                    <a className={classes.footerPolicy} href="/privacy-policy-and-cookies">
                        Privacy Policy
                    </a>
                    <a className={classes.footerPolicy} href="/cookie-policy">
                        Cookie Policy
                    </a>
                </div>
            </>
        )}
    </div>
);
